import { useTranslation } from 'react-i18next';
import { S, formatDate } from '../../regureStyles';
import Card from './Card';

const DocumentInfo = ({request}) => {
  const { t } = useTranslation();
  const rows = [
    [t('screens.esign.labelTitle'), request.title],
    [t('screens.esign.labelFile'), request.document?.fileName || '—'],
    [t('screens.esign.labelCreatedBy'), request.createdBy?.name || '—'],
    [t('screens.esign.labelCreated'), request.createdAt ? formatDate(request.createdAt) : '—'],
    [t('screens.esign.labelExpires'), request.expiresAt ? formatDate(request.expiresAt) : '—'],
    [t('screens.esign.labelSha'), request.document?.originalHash ? request.document.originalHash.slice(0, 16) + '…' : '—'],
  ];
  return (
    <Card title={t('screens.esign.cardDocument')}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {rows.map(([label, value]) => (
          <div key={label}>
            <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 3 }}>{label}</div>
            <div style={{ fontSize: 13, color: S.textPrimary, fontFamily: label.includes('SHA') ? 'monospace' : 'inherit' }}>{value}</div>
          </div>
        ))}
        {request.description && (
          <div style={{ gridColumn: '1/-1' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 3 }}>{t('screens.esign.labelDescription')}</div>
            <div style={{ fontSize: 13, color: S.textPrimary }}>{request.description}</div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default DocumentInfo;
